import React, { useContext, useState, useEffect } from 'react';
import styles from './styles.module.css';
import CategoryListView from '../../utils/CategoryListView';
import ProductListView from '../../utils/ProductList/ProductListView';
import { ShopContext } from '../../../contexts/ShopContext';
import SearchField from '../../utils/CustomerComponents/SearchField';
import NavBar from '../../utils/NavBar/NavBar';
import CartViewBar from '../../utils/CartViewBar/CartViewBar';
import { CartContext } from '../../../contexts/CartContext';
import { SHOP_MODE, QUERY_PARAM_PIEFIX_KEY } from '../../../const';
import ProductService from '../../../services/ProductService';
import { useLocation } from 'react-router-dom';
import { getQueryParamKey } from '../../utils/queryParamUtils';
import Loader from '../../utils/Loader/Loader';

function ProductsPage(props) {
  const { shop, loading: shopContextLoading } = useContext(ShopContext);
  const { itemsCount } = useContext(CartContext);
  const { pathname, search } = useLocation();

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchKey, setSearchKey] = useState('');
  const [products, setProducts] = useState([]);

  useEffect(() => {
    async function fetchProducts() {
      if (!selectedCategory || !shop?.shopId) return;
      const list = await ProductService.getProducts(shop, selectedCategory.id);
      setProducts(list);
    }
    fetchProducts();
  }, [selectedCategory, shop]);

  const openProductDetailsPage = ({ shop, category, product }) => {
    props.history.push(`/${shop.shopId}/products/${category.id}/${product.id}`);
  };

  const handleChangeSearchKey = (e) => {
    setSearchKey(e.target.value);
  };

  const clearSearchKey = () => {
    setSearchKey(null);
  };

  const handleSetSelectedCategory = (category) => {
    setSelectedCategory(category);
    ProductService.setSelectedCategory(category);
  };

  const isViewOnly = shop?.mode === SHOP_MODE.VIEW_ONLY;

  useEffect(() => {
    const savedCategory = ProductService.getSelectedCategory();
    if (savedCategory) {
      setSelectedCategory(savedCategory);
    }
  }, []);

  useEffect(() => {
    if (!shop?.shopId) return;
    if (search && search.length > 1) {
      const params = Object.fromEntries(new URLSearchParams(search));
      const key = shop?.shopId ? getQueryParamKey(shop.shopId) : QUERY_PARAM_PIEFIX_KEY;

      const payload = {
        data: params,
        createdAt: Date.now(),
      };

      localStorage.setItem(key, JSON.stringify(payload));
    }
  }, [pathname, search, shop]);

  return (
    <div className={styles.container}>
      <Loader isOpen={shopContextLoading} />
      <span className={styles.header}>{shop?.shop_name ?? shop?.name}</span>
      <SearchField placeholder="Search for your favorite products" onChange={handleChangeSearchKey} value={searchKey} />
      <CategoryListView
        shop={shop}
        fcnSetSelectedCategory={handleSetSelectedCategory}
        searchKey={searchKey}
        clearSearchKey={clearSearchKey}
        selectedCategory={selectedCategory}
      />
      <div className={`${styles.productContainer} ${isViewOnly ? styles.productContainerWithoutNavBar : ''} ${itemsCount > 0 ? styles.withCartBar : ''}`}>
        <ProductListView
          selectedCategory={selectedCategory}
          fnOpenProductDetailsPage={openProductDetailsPage}
          searchKey={searchKey}
          products={products}
        />
      </div>
      {itemsCount > 0 && <CartViewBar />}
      {!isViewOnly && <NavBar />}
    </div>
  );
}

export default ProductsPage;
